import { StaticImageData } from 'next/image'

import {
  WelcomeSection001Image,
  WelcomeSection002Image,
  WelcomeSection003Image,
  WelcomeSection004Image,
} from 'Assets/Images/Sections/WelcomeSection'

export enum WelcomeSectionGalleryItemId {
  Access = 'Access',
  Learn = 'Learn',
  Grow = 'Grow',
  Emajin = 'Emajin',
}

type WelcomeSectionGalleryItem = {
  id: WelcomeSectionGalleryItemId
  image: StaticImageData
  title: string
  caption: string
}

export const WELCOME_SECTION_GALLERY_ITEMS: WelcomeSectionGalleryItem[] = [
  {
    id: WelcomeSectionGalleryItemId.Access,
    image: WelcomeSection001Image,
    title: 'Access',
    caption: 'top courses.',
  },
  {
    id: WelcomeSectionGalleryItemId.Learn,
    image: WelcomeSection002Image,
    title: 'Learn',
    caption: 'from top voices.',
  },
  {
    id: WelcomeSectionGalleryItemId.Grow,
    image: WelcomeSection003Image,
    title: 'Grow',
    caption: 'your network.',
  },
  {
    id: WelcomeSectionGalleryItemId.Emajin,
    image: WelcomeSection004Image,
    title: 'Emajin',
    caption: 'the possibilities.',
  },
]
